import React from 'react'

import * as S from './error-message.styled'

interface ErrorMessageProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode
}

export const ErrorMessage = ({ children, ...props }: ErrorMessageProps) => {
  if (!children) return null

  return (
    <S.Wrapper {...props}>
      <S.Message>{children}</S.Message>
    </S.Wrapper>
  )
}
